export default __webpack_public_path__ + "locales/az/SharingPanel.json?hash=88485d477db097b1aa4318f98114fe0e";